import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Target } from 'lucide-react'
import { useTranslation } from '../hooks/use-i18n'

interface TopScorerExistedModalProps {
  eventName: string
  currentChoice: string
  onKeepClick: () => void
  onChangeClick: () => void
}

const TopScorerExistedModal: React.FC<TopScorerExistedModalProps> = ({
  eventName,
  currentChoice,
  onKeepClick,
  onChangeClick,
}) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  if (!isOpen) return null

  return createPortal(
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="blue-sky-card rounded-3xl p-4 sm:p-6 w-full max-w-md mx-4 shadow-2xl">
        <div className="text-center mb-4">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/10 mb-3">
            <Target className="w-6 h-6 text-emerald-400" />
          </div>
          <h2 className="text-lg font-bold text-white mb-1">{eventName}</h2>
          <p className="text-white/80 font-semibold text-sm">{t('predictions.alreadyPlayed')}</p>
        </div>
        <div className="bg-white/10 rounded-xl p-4 mb-4">
          <p className="text-white/70 text-xs mb-1">{t('topScorer.yourPrediction')}</p>
          <p className="text-white font-semibold">{currentChoice}</p>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => {
              onKeepClick()
              setIsOpen(false)
            }}
            className="flex-1 py-2.5 rounded-xl bg-primary text-primary-foreground font-semibold"
          >
            {t('predictions.keep')}
          </button>
          <button
            type="button"
            onClick={() => {
              onChangeClick()
              setIsOpen(false)
            }}
            className="flex-1 py-2.5 rounded-xl bg-white/10 text-white font-semibold border border-white/20"
          >
            {t('predictions.change')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default TopScorerExistedModal
